export default __webpack_public_path__ + "static/media/logo.6fa47d29.svg";